import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import { RiSearch2Line } from "react-icons/ri";
import { ButtonComp } from "../Ui";

export default function FilterFind({
  title,
  back,
  backBtn,
  rightSide = "search",
  rightSideComponent,
  onChange,
  searchValue = "",
  onSearchChange,
  placeholder,
  showEventTypeFilter = false,
  eventType,
  onEventTypeChange,
  showAttendeeFilter = false,
  attendeeType,
  onAttendeeChange,
  isLoading = false,
}) {
  return (
    <div className="mb-3">
      <div className="card border-0 px-lg-3">
        <div className="card-body">
          <div className="row justify-content-between align-items-center mb-0 flex-wrap">
            <div className="flex items-center col-lg-6 ">
              {back && (
                <BsArrowLeft
                  size={30}
                  onClick={() => backBtn()}
                  className="me-3 pointer"
                />
              )}
              <h4 className="fw-bold mb-0" style={{ fontSize: "24px", color: "#383838" }}>
                {title}
              </h4>
            </div>
            {rightSide && (
              <div className="col-lg-6">
                {rightSide === "search" ? (
                  <div className="d-flex gap-2 flex-wrap">
                    <div
                      className="input-group search flex-grow-1"
                      style={{ minWidth: "200px" }}
                    >
                      <span className="input-group-text bg-table-header px-4 py-0 my-0">
                        {isLoading ? (
                          <div
                            className="spinner-border spinner-border-sm text-white"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <RiSearch2Line size={25} color={"#fff"} />
                        )}
                      </span>
                      <input
                        type="text"
                        className="form-control py-3 bg-gary3"
                        placeholder={placeholder || "Search events..."}
                        value={searchValue}
                        onChange={onSearchChange || onChange}
                        disabled={isLoading}
                      />
                    </div>

                    {showEventTypeFilter && (
                      <select
                        className="form-select py-3"
                        value={eventType || ""}
                        onChange={(e) =>
                          onEventTypeChange && onEventTypeChange(e.target.value)
                        }
                        style={{ minWidth: "120px" }}
                        disabled={isLoading}
                      >
                        <option value="">All Types</option>
                        <option value="upcoming">Upcoming</option>
                        <option value="current">Current</option>
                        <option value="past">Past</option>
                      </select>
                    )}

                    {showAttendeeFilter && (
                      <select
                        className="form-select py-3"
                        value={attendeeType || ""}
                        onChange={(e) =>
                          onAttendeeChange && onAttendeeChange(e.target.value)
                        }
                        style={{ minWidth: "120px" }}
                        disabled={isLoading}
                      >
                        <option value="">All Attendees</option>
                        <option value="MEMBER">Members</option>
                        <option value="STAFF">Staff</option>
                        <option value="BOTH">Both</option>
                      </select>
                    )}
                  </div>
                ) : rightSideComponent ? (
                  rightSideComponent
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
